/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCaseAssignedStatus,
    InternalApiCaseAssignedStatusFromJSON,
    InternalApiCaseAssignedStatusToJSON,
    InternalApiUpdateCaseAssignedStatusRequest,
    InternalApiUpdateCaseAssignedStatusRequestFromJSON,
    InternalApiUpdateCaseAssignedStatusRequestToJSON,
} from '../models';

export interface UpdateCaseAssignedStatusRequest {
    handle: string;
    internalApiUpdateCaseAssignedStatusRequest: InternalApiUpdateCaseAssignedStatusRequest;
}

/**
 * 
 */
export class CaseAssignedStatusInternalApi extends runtime.BaseAPI {

    /**
     * Changes the assigned status of a case
     */
    async updateCaseAssignedStatusRaw(requestParameters: UpdateCaseAssignedStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCaseAssignedStatus>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling updateCaseAssignedStatus.');
        }

        if (requestParameters.internalApiUpdateCaseAssignedStatusRequest === null || requestParameters.internalApiUpdateCaseAssignedStatusRequest === undefined) {
            throw new runtime.RequiredError('internalApiUpdateCaseAssignedStatusRequest','Required parameter requestParameters.internalApiUpdateCaseAssignedStatusRequest was null or undefined when calling updateCaseAssignedStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/assigned-status`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateCaseAssignedStatusRequestToJSON(requestParameters.internalApiUpdateCaseAssignedStatusRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCaseAssignedStatusFromJSON(jsonValue));
    }

    /**
     * Changes the assigned status of a case
     */
    async updateCaseAssignedStatus(requestParameters: UpdateCaseAssignedStatusRequest, initOverrides?: RequestInit): Promise<InternalApiCaseAssignedStatus> {
        const response = await this.updateCaseAssignedStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
